/**
 * @deprecated This component is no longer used on mobile.
 * The New Session button is now rendered in the MobileSidebar header via SessionsPanelAction.
 * This component only exists for backwards compatibility and returns null.
 */
function SessionBarNewSessionMobileButton() {
  // On mobile, the new session action is now in the MobileSidebar header
  // via SessionsPanelAction. This component is kept for backwards compatibility
  // but no longer renders anything.
  return null;
}

export default SessionBarNewSessionMobileButton;
